import { Controller, Control, FieldErrors } from 'react-hook-form'
import { LabelDatePicker } from '@/common/ui/LabelDatePicker'
import { ONBOARDING_COPY } from '@/locales/en'

interface DateOfBirthFieldProps {
    control: Control<any>
    error?: string
    formErrors?: FieldErrors<any>
}

/**
 * Reusable Date of Birth field component.
 *
 * Encapsulates the Controller + LabelDatePicker pattern used across onboarding forms.
 * Handles date conversion to/from ISO format (YYYY-MM-DD).
 *
 * Validation is handled by the schema (must use dateOfBirthValidator from shared validators).
 */
export function DateOfBirthField({ control, error, formErrors }: DateOfBirthFieldProps) {
    return (
        <Controller
            name="dateOfBirth"
            control={control}
            render={({ field }) => (
                <LabelDatePicker
                    id="dateOfBirth"
                    label={ONBOARDING_COPY.aboutYou.form.dateOfBirth}
                    placeholder={ONBOARDING_COPY.aboutYou.form.dateOfBirthPlaceholder}
                    value={field.value ? new Date(field.value) : undefined}
                    onChange={(date) => field.onChange(date ? date.toISOString().slice(0, 10) : '')}
                    required
                    error={error || (formErrors?.dateOfBirth?.message as string)}
                    minDate={new Date('1900-01-01')}
                    maxDate={new Date()}
                />
            )}
        />
    )
}
